type WindowWithFbq = Window & {
  fbq?: (...args: unknown[]) => void;
};

declare const window: WindowWithFbq;

export const META_PIXEL_ID = "1143007268388723";

/** Meta standard events Helios reports; custom names do not optimize ads. */
export type MetaStandardEvent =
  | "Lead"
  | "Schedule"
  | "CompleteRegistration"
  | "StartTrial"
  | "Subscribe";

/**
 * Sends a standard event when the pixel is loaded (`AdTags`, prod only);
 * a no-op everywhere else. PageView is not tracked here: the pixel fires it
 * on load and on every history change by itself.
 */
export function trackMetaEvent(event: MetaStandardEvent, params?: Record<string, unknown>) {
  if (typeof window === "undefined" || typeof window.fbq !== "function") {
    return;
  }
  try {
    window.fbq("track", event, params);
  } catch (err) {
    console.error("[meta-pixel] track:", err);
  }
}
